import { Sparkles } from 'lucide-react';
import { SIGNUP_SOURCE, trackSignupCta } from '@ui/analytics/events.js';
import ModuleLink from '@ui/ModuleLink.jsx';

// The public pricing page - a placeholder splash for now (docs/tourGuide.md
// calls for a plan picker but says it's "yet to be built"; no payment flow
// exists yet either). Landed on from TRIAL_QUOTA_EXCEEDED (a device's
// demo/trial has already been used) and from the tour-guide paywall CTA.
//
// It lives in the web module rather than with the product because it has to
// RANK - a pricing page is one of the highest-intent queries a product like
// this gets (docs/frontend-modules-plan.md §3). The authenticated "change my
// plan" flow is a different screen and belongs to app/app.
//
// Its old URL was /subscribe, kept working by routes/legacy-redirect.jsx.
export function meta() {
  return [
    { title: 'Pricing · WriteUp' },
    {
      name: 'description',
      content: 'Plans and pricing for WriteUp - turn scanned repair orders into clean tech write-ups and customer-ready summaries.'
    }
  ];
}

export default function Pricing() {
  return (
    <div className="max-w-lg mx-auto my-16 text-center">
      <div className="w-16 h-16 bg-brand/10 rounded-2xl border border-brand/40 flex items-center justify-center mx-auto mb-4 text-brand">
        <Sparkles className="w-8 h-8" />
      </div>
      <h1 className="text-xl font-semibold text-paper mb-2">You've used up your free preview</h1>
      <p className="text-ink-400 text-sm mb-8 max-w-sm mx-auto">
        Create a free account to keep processing repair orders - no card required to get started.
      </p>
      {/* A different module owns /sign-up - a document navigation, not a
          client-side one. See @ui/ModuleLink.jsx. */}
      <ModuleLink
        to="/sign-up"
        onClick={() => trackSignupCta(SIGNUP_SOURCE.SUBSCRIBE_PAGE)}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-brand text-ink-900 rounded-lg text-sm font-medium hover:bg-brand-600 transition shadow-lg shadow-brand/20"
      >
        Create a free account
      </ModuleLink>
    </div>
  );
}
